export default "__VITE_ASSET__776ea09a__"